"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _IssuesConsumer = require("../IssuesConsumer");
var _columnKeys = require("../IssuesTab/IssueLog/IssueTable/columnKeys");
var _useIssuesTableData = require("../IssuesTab/IssueLog/IssueTable/useIssuesTableData");
var _referencePickerComponents = require("../reference-picker-components");
var _accReferencePicker = require("@adsk/acc-reference-picker");
var _useTranslations = require("../utils/i18n/useTranslations");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const IssuesCustomDataView = (0, _IssuesConsumer.withIssuesConsumer)(_ref => {
  let {
    disabledIds = [],
    selectedIds = [],
    entities = [],
    filters = {},
    onLoadMore,
    onChange,
    multiple,
    loading,
    error,
    setSelection,
    onTryAgain
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const dataColumns = (0, _referencePickerComponents.useIssuesReferencePickerTableColumns)();
  const transformedEntities = (0, _useIssuesTableData.useIssuesTableData)(entities);
  const columns = (0, _react.useMemo)(() => {
    const COLUMN_WIDTH_BY_KEY = {
      [_columnKeys.ISSUE_COLUMN_KEYS.ID]: "8%",
      [_columnKeys.ISSUE_COLUMN_KEYS.TITLE]: "20%",
      [_columnKeys.ISSUE_COLUMN_KEYS.STATUS]: "11%",
      [_columnKeys.ISSUE_COLUMN_KEYS.ISSUE_TYPE]: "18%",
      [_columnKeys.ISSUE_COLUMN_KEYS.ASSIGNED_TO]: "14%",
      [_columnKeys.ISSUE_COLUMN_KEYS.DUE_DATE]: "11%",
      [_columnKeys.ISSUE_COLUMN_KEYS.PLACEMENT]: "18%"
    };
    return [{
      key: "selection",
      width: 40,
      minWidth: 40,
      selectedIds,
      cellRenderer: _ref2 => {
        let {
          rowData
        } = _ref2;
        return /*#__PURE__*/_react.default.createElement(_accReferencePicker.EntitiesTable.SelectionCell, {
          multiple: multiple,
          rowData: rowData,
          onChange: onChange,
          disabledIds: disabledIds,
          selectedIds: selectedIds
        });
      },
      ...(multiple && {
        headerRenderer: () => /*#__PURE__*/_react.default.createElement(_accReferencePicker.EntitiesTable.SelectionCellHeader, {
          entities: transformedEntities,
          selectedIds: selectedIds,
          disabledIds: disabledIds,
          setSelection: setSelection
        })
      })
    }, ...dataColumns.map(col => ({
      ...col,
      width: col.key ? COLUMN_WIDTH_BY_KEY[col.key] : "".concat(1 / dataColumns.length * 100, "%"),
      minWidth: undefined,
      sortable: false // Setting as false because we haven't implemented column sorting
    }))];
  }, [selectedIds, multiple, dataColumns, onChange, disabledIds, transformedEntities, setSelection]);
  return /*#__PURE__*/_react.default.createElement(_accReferencePicker.EntitiesTable, {
    loadingMoreText: T.translate("referencePickerPlugin.fetchingMoreResults"),
    errorText: T.translate("referencePickerPlugin.couldNotLoadContent"),
    columns: columns,
    disabledIds: disabledIds,
    selectedIds: selectedIds,
    entities: transformedEntities,
    filters: filters,
    onLoadMore: onLoadMore,
    onChange: onChange,
    multiple: multiple,
    loading: loading,
    error: error,
    setSelection: setSelection,
    onTryAgain: onTryAgain
  });
});
IssuesCustomDataView.displayName = "IssuesCustomDataView";
var _default = exports.default = IssuesCustomDataView;
//# sourceMappingURL=IssuesCustomDataView.js.map